<template>
  <div v-if="message.lastMessage" class="loading-message">
    <loading-indicator />
  </div>
</template>

<script>
import LoadingIndicator from '../../../../common/components/LoadingIndicator/LoadingIndicator.vue'

export default {
  components: { LoadingIndicator },
  props: {
    message: {
      type: Object,
      default: () => {
      }
    }
  }
}
</script>

<style src="./loading-message.scss" />
